import { isCSR } from '@raisin/cp-utils';
const apiRoutes = {
    production: {
        customer: {
            data: '/customer',
            productAccess: '/customer/product/access',
            //To be deprecated
            transactionAccount: '/transaction_account',
            cobranding: '/cobranding',
        },
        dashboard: {
            pensionProducts: '/pension/customer/products',
            pensionProductsMigrated: '/products',
        },
        logout: '/logout',
        pia: {
            productInstances: '/product_instance',
        },
        pom: {
            products: '/products',
        },
        postbox: {
            unreadCount: '/threads/unread-count',
        },
        deposits: { dbsDepositsTypes: '/deposits/types' },
        products: { productsTypes: '/products/types' },
    },
    local: {},
};
if (process.env.NODE_ENV === 'development' ||
    (isCSR() && window.location.hostname === 'localhost')) {
    apiRoutes.local = {
        customer: {
            data: '/customerData.json',
            productAccess: '/productAccess.json',
            //To be deprecated
            transactionAccount: '/transactionAccount.json',
            cobranding: '/cobranding.json',
        },
        dashboard: {
            pensionProducts: '/pensionProductsData.json',
            pensionProductsMigrated: '/pensionProductsData.json',
        },
        logout: '/customerData.json',
        pia: {
            productInstances: '/piaProductInstances.json',
        },
        pom: {
            products: '/pomProductsData.json',
        },
        postbox: {
            unreadCount: '/postboxUnreadCount.json',
        },
        deposits: { dbsDepositsTypes: '/dbsDepositsTypes.json' },
        products: { productsTypes: '/productsTypes.json' },
    };
}
export default apiRoutes;
//# sourceMappingURL=apiRoutes.js.map